import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { MegaleiosAlertComponent } from './megaleios-alert.component';

// services
import { MegaleiosAlertService } from './megaleios-alert.service';

@NgModule({
  declarations: [
    // components
    MegaleiosAlertComponent
  ],
  imports: [
    CommonModule,
    // modules

  ],
  exports: [
    // components
    MegaleiosAlertComponent
  ],
  providers: [
    // services
    MegaleiosAlertService
  ]
})
export class MegaleiosAlertModule { }
